export const formatString = (text: string) => text?.trim() || '-';
